var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        id: "stock-message",
        title: "Send Stock Message",
        "no-fade": "",
        size: "lg"
      },
      on: {
        change: _vm.onModalChange,
        hide: _vm.onModalChange,
        show: _vm.onModalChange
      },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function() {
            return [
              _c("b-btn", { on: { click: _vm.cancelModal } }, [
                _vm._v("Cancel")
              ]),
              _vm._v(" "),
              _c(
                "b-btn",
                {
                  attrs: {
                    disabled: !_vm.selectedUserIds.length,
                    title: _vm.selectedUserIds.length
                      ? ""
                      : "Add some users to send."
                  },
                  on: {
                    click: function($event) {
                      return _vm.submit()
                    }
                  }
                },
                [_vm._v("Send")]
              )
            ]
          },
          proxy: true
        }
      ]),
      model: {
        value: _vm.modalOpen,
        callback: function($$v) {
          _vm.modalOpen = $$v
        },
        expression: "modalOpen"
      }
    },
    [
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-12" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.notifySubject,
                expression: "notifySubject"
              }
            ],
            attrs: { type: "text", name: "emailSubject", id: "emailSubject" },
            domProps: { value: _vm.notifySubject },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.notifySubject = $event.target.value
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-12" }, [
          _c(
            "textarea",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.notifyMessage,
                  expression: "notifyMessage"
                }
              ],
              attrs: { name: "emailMessage", id: "emailMessage" },
              domProps: { value: _vm.notifyMessage },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.notifyMessage = $event.target.value
                }
              }
            },
            [
              _vm._v(
                "                " +
                  _vm._s(_vm.notifyMessage) +
                  "\n            "
              )
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-12" }, [
          _vm.userList && _vm.userList.length
            ? _c("div", [
                _c("div", { staticClass: "row detail mb-3" }, [
                  _c(
                    "div",
                    { staticClass: "col-md-1" },
                    [
                      _c("b-checkbox", {
                        model: {
                          value: _vm.selectAll,
                          callback: function($$v) {
                            _vm.selectAll = $$v
                          },
                          expression: "selectAll"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-11 select-all-checkbox" }, [
                    _vm._v(
                      "\n                        Select All users\n                    "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "accordion", attrs: { role: "tablist" } },
                  _vm._l(_vm.repGroupedUsers, function(users, repName, index) {
                    return _c(
                      "b-card",
                      {
                        key: index,
                        staticClass: "mb-1",
                        attrs: { "no-body": "" }
                      },
                      [
                        _c(
                          "b-card-header",
                          {
                            staticClass: "p-1",
                            attrs: { "header-tag": "header", role: "tab" }
                          },
                          [
                            _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "b-toggle",
                                    rawName: "v-b-toggle",
                                    value: "accordion-" + index,
                                    expression: "`accordion-${index}`"
                                  }
                                ],
                                attrs: { block: "", variant: "info" }
                              },
                              [_vm._v(_vm._s(repName))]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-collapse",
                          {
                            attrs: {
                              id: "accordion-" + index,
                              accordion: "my-accordion",
                              role: "tabpanel",
                              visible: false
                            }
                          },
                          [
                            _c(
                              "b-card-body",
                              [
                                _c("div", { staticClass: "row detail mb-3" }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-md-1" },
                                    [
                                      _c("b-checkbox", {
                                        on: {
                                          click: function($event) {
                                            return _vm.toggleRepGroup(repName)
                                          },
                                          change: function($event) {
                                            return _vm.toggleRepGroup(repName)
                                          }
                                        },
                                        model: {
                                          value: _vm.repSelectAll[repName],
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.repSelectAll,
                                              repName,
                                              $$v
                                            )
                                          },
                                          expression: "repSelectAll[repName]"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-md-11 rep-toggle-checkbox"
                                    },
                                    [
                                      _vm._v(
                                        "\n                                        Select All Users for " +
                                          _vm._s(repName) +
                                          "\n                                    "
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _vm._l(users, function(user) {
                                  return _c(
                                    "div",
                                    {
                                      key: user.id + repName,
                                      staticClass: "row detail mb-2"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "col-md-1" },
                                        [
                                          _c("b-checkbox", {
                                            attrs: {
                                              value: user.id,
                                              disabled: !user.privileges[
                                                _vm.privileges_to_check
                                              ]
                                            },
                                            model: {
                                              value: _vm.selectedUserIds,
                                              callback: function($$v) {
                                                _vm.selectedUserIds = $$v
                                              },
                                              expression: "selectedUserIds"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "col-md-6 link" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "member-name" },
                                            [_vm._v(_vm._s(user.name))]
                                          ),
                                          _vm._v(" "),
                                          user.company
                                            ? _c("span", [
                                                _vm._v(
                                                  "(" +
                                                    _vm._s(user.company.name) +
                                                    ")"
                                                )
                                              ])
                                            : _vm._e()
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "col-md-5" },
                                        [
                                          !user.privileges[
                                            _vm.privileges_to_check
                                          ]
                                            ? [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(
                                                      _vm.privileges_message
                                                    ) +
                                                    "\n                                        "
                                                )
                                              ]
                                            : _vm._e()
                                        ],
                                        2
                                      )
                                    ]
                                  )
                                })
                              ],
                              2
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  }),
                  1
                )
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _vm.repList && _vm.repList.length
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-12" }, [
              _c("div", { staticClass: "send-from-rep-wrapper" }, [
                _c(
                  "div",
                  { staticClass: "col-md-6 send-from-rep" },
                  [
                    _c(
                      "b-checkbox",
                      {
                        model: {
                          value: _vm.sendFromRep,
                          callback: function($$v) {
                            _vm.sendFromRep = $$v
                          },
                          expression: "sendFromRep"
                        }
                      },
                      [_vm._v("Send from rep")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-6" },
                  [
                    _vm.sendFromRep
                      ? _c(
                          "b-select",
                          {
                            attrs: {
                              options: _vm.repList,
                              "text-field": "name",
                              "value-field": "id"
                            },
                            model: {
                              value: _vm.fromRep,
                              callback: function($$v) {
                                _vm.fromRep = $$v
                              },
                              expression: "fromRep"
                            }
                          },
                          [
                            _c(
                              "b-form-select-option",
                              { attrs: { value: null, disabled: "" } },
                              [_vm._v("-- Select from rep --")]
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              ])
            ])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5cfc4660", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cfc4660","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/VehicleStock/VehicleStockSendEmail.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-5cfc4660","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/VehicleStock/VehicleStockSendEmail.vue
// module chunks = 0